<template>
	<v-layout>
		<MainMenu @showLogin="show_login = !show_login" @showRoutes="show_boats_route = !show_boats_route"
			@showNextWaypoint="show_next_waypoint = !show_next_waypoint"
			@showWaypoints="show_waypoints = !show_waypoints" @showWind="show_wind = !show_wind"
			:hide-button="show_vehicle_info" :showVehicleInfo="show_vehicle_info"
			@showInfo="show_vehicle_info = !show_vehicle_info" @layers="changeLayers">

			<SearchMission :is_user_logged="is_user_logged"
				:is_logged_user_admin="user_perms.some(e => e.name == 'show_admin_panel')"
				:show_recomend_search="show_recomend_search" @add="addMission" @show_login="show_login = true"
				@input_search_focused="show_recomend_search = true" />
		</MainMenu>
		<v-main>
			<div class="map-container">
				<Map :show_boats_route="show_boats_route" :show_next_waypoint="show_next_waypoint"
					:show_waypoints="show_waypoints" :show_wind="show_wind" :zoomControl="true" :layers="layers"
					@mapFocused="show_recomend_search = false" @mapUnfocused="show_recomend_search = false"
					:centerMapPoint="centerMapPoint">
				</Map>


				<BoatInfo v-if="show_vehicle_info" :id="vehicle_to_show" @close="show_vehicle_info = false" />

				<SelectedMissionsList @goToMissionPosition="handleGoToMissionPosition" :newMission="new_added_mission"
					@closeVehicleInfo="show_vehicle_info = false" />
				<LoginModal v-model="show_login" />
			</div>

		</v-main>
	</v-layout>
</template>

<script setup>
import { ref } from 'vue';
import BoatInfo from '@/components/boatInfo/BoatInfo.vue';
import SearchMission from '@/components/searchMission/SearchMission.vue';
import SelectedMissionsList from '@/components/selectedMissions/SelectedMissionsList.vue';
import LoginModal from '@/components/LoginModal.vue';
import MainMenu from '@/components/Menu.vue'
import Map from '@/components/Map.vue';
import { useNotificationStore } from '@/store/notificationStore';

const props = defineProps({
	is_user_logged: Boolean,
	user_perms: Array
})

const centerMapPoint = ref(null);
const show_vehicle_info = ref(null);
const vehicle_to_show = ref();
const show_boats_route = ref(false);
const show_next_waypoint = ref(false);
const show_waypoints = ref(false);
const show_wind = ref(false);
const show_login = ref(false);
const show_recomend_search = ref(false);
const show_depth_contour = ref(false);
const show_marine_profile = ref(false);
const new_added_mission = ref(null);

const layers = ref([]);


const checkPosition = async (records, P, fields) => {
	const record = records[P];
	return record && record[fields.latitudeKey] != null && record[fields.longitudeKey] != null
		? [record[fields.latitudeKey], record[fields.longitudeKey]]
		: null;
};

const handleGoToMissionPosition = async (mission, vehicle_id) => {
	try {
		const indexVehicle = mission.vehicles.findIndex((vehicle) => vehicle_id == vehicle.id);
		const position = await checkPosition(mission.vehicles[indexVehicle].records, mission.vehicles[indexVehicle].P, mission.vehicles[indexVehicle].fields);
		if (!position) {
			useNotificationStore().setNotification("Warning", "Cannot center the map—no records found for vehicle " + mission.vehicles[indexVehicle].name + ".", "mdi-alert", "orange");
			return;
		}
		if (mission.vehicles[indexVehicle]) {
			centerMapPoint.value = position;
		}
	} catch (error) {
		useNotificationStore().setNotification("Error", "While trying to center the mission", "mdi-alert", "red");
	}

}

const addMission = (new_mission) => {
	console.log(new_mission);
	new_added_mission.value = new_mission;
	setTimeout(() => {
		new_added_mission.value = null;
	}, 200);
};


const changeLayers = (event) => {
	layers.value = event;
}



</script>

<style lang="stylus" scoped>
  @import "../assets/css/generalColors.styl";

  .info-button-no-vehicle-info {
	top: 20px;
	right: 10px;
	position: absolute;
	z-index: 1000;
  }

  .info-button-with-vehicle-info {
	bottom : 20px;
	right: 10px;
	position: absolute;
	z-index: 1000
  }
  
  .map-container {
	height: 100vh;
	position: relative;
  }
  
  .control-buttons {
	position: absolute;
	z-index: 2002;
	bottom: 10px;
	left: 10px;
  
	button {
	  border: none;
	  border-radius: 5px;
	  background-color: transparent;
	  color: var(--main-color);
	  padding: 3px 5px 1px 5px;
	  font-weight: bold;
	  cursor: pointer;
  
	  &:not(:last-child) {
		margin-right: 10px;
	  }
  
	  &:hover {
		background-color: var(--third-color);
		box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.15);
	  }
  
	  &.active {
		background-color: var(--main-color);
		box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.15);
  
		svg {
		  fill: var(--third-color);
		}
	  }
  
	  svg {
		height: 30px;
		fill: var(--main-color);
	  }
	}
  }

  $list-color{
	
  }
  
  .login-container {
	position: absolute;
	top: 5px;
	right: 5px;
	z-index: 2002;
  
	svg {
	  width: 40px;
	}
  }
  </style>